import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { BodyWrapper, Header } from '@components';
import { legacyDashboardURL } from '@helpers';
import { businessQuery, siteQuery } from '@queries';

import { TemplateSidebar } from '../components/TemplateSidebar/TemplateSidebar.jsx';

import './TemplateEditor.scss';

export const TemplateEditor = () => {
  const { businessID, siteID } = useParams();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // get site/template
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // Just navigate to menus for now
  return (
    <>
      <Header />
      <BodyWrapper>
        <TemplateSidebar
          businessID={businessID}
          businessData={businessData}
          siteID={siteID}
          siteData={siteData}
        />
        <iframe
          className="sb-sitebuilder-iframe"
          src={legacyDashboardURL(`/app/builder/${siteID}`)}
        ></iframe>
      </BodyWrapper>
    </>
  );
};
